import {API_URL,Accept} from '../constants.js';
import {notify} from 'react-notify-toast';
import api from "./api.js";
export default function feedback(component,orderfeedback){
  const Authorization='bearer '+localStorage.getItem('token');
  const rider_id=localStorage.getItem('rider_id');
  fetch(`${API_URL}rest/V1/rider/saveDeliveryConfirmation`,{
    method:'POST',
    headers:{"Content-Type": "application/json",Accept,Authorization},
      body:JSON.stringify({data:orderfeedback})
        }).then(function(response){
          if(!response.ok){
              notify.show('Network Failure','error');
          }
            return response.json();
        })
        .then(function(data) {
          console.log("datafeedback",data);
          component.setState({
            signFeedbackstate: data[0].status
              });
             
            //api.callAssignedJobs(component,'assigned');
    })
}



// WEBPACK FOOTER //
// ./src/utility/api/feedback.js